import {
  SET_SAAS_TENANTS,
  ISetSaasTenantsAction,
  ADD_SAAS_TENANT,
  IAddSaasTenantAction,
  UPDATE_SAAS_TENANT,
  IUpdateSaasTenantAction,
  DELETE_SAAS_TENANT,
  IDeleteSaasTenantAction,
  SET_SAAS_TENANT_CONFIRMED_BY_BACKEND,
  ISetSaasTenantConfirmedByBackendAction,
  CLEAR_SAAS_TENANTS,
  IClearSaasTenantsAction,
  UPDATE_SAAS_TENANT_USAGE,
  IUpdateSaasTenantUsageAction,
  SET_SAAS_TENANT_SEARCH_RESULTS,
  ISetSaasTenantSearchResultsAction,
  SET_SAAS_TENANT_SEARCH_TOO_MANY_RESULTS,
  ISetSaasTenantSearchTooManyResultsAction,
  INewSaasTenant,
  ISaasTenant,
  ISaasTenantSearchResult,
  ICreateSaasTenantParams,
} from './types';
import { WsCommandSubject } from '../crud/types';
import { prepareCreateCommandAction, prepareReadCommandAction, prepareUpdateCommandAction, prepareDeleteCommandAction } from '../crud/actions';

// CRUD operations
export const prepareCreateSaasTenantCommandAction = (saasTenant: INewSaasTenant) =>
  prepareCreateCommandAction({
    type: 'saasTenants' as WsCommandSubject,
    params: saasTenant as ICreateSaasTenantParams,
  });

export const prepareReadSaasTenantsCommandAction = () =>
  prepareReadCommandAction({
    type: 'saasTenants' as WsCommandSubject,
    params: { usage: {} },
  });

export const prepareSearchSaasTenantNamesCommandAction = (nameSubstring: string) =>
  prepareReadCommandAction({
    type: 'saasTenants' as WsCommandSubject,
    params: { nameSubstring },
  });

export const prepareUpdateSaasTenantCommandAction = (saasTenant: INewSaasTenant) =>
  prepareUpdateCommandAction({
    type: 'saasTenants' as WsCommandSubject,
    params: saasTenant,
  });

export const prepareDeleteSaasTenantCommandAction = (saas_tenant_id: string) =>
  prepareDeleteCommandAction({
    type: 'saasTenants' as WsCommandSubject,
    params: { saas_tenant_id },
  });

export const setSaasTenantConfirmedByBackendAction = (
  saas_tenant_id: string,
  updated_at: string,
  saas_tenant_name?: string,
): ISetSaasTenantConfirmedByBackendAction => ({
  type: SET_SAAS_TENANT_CONFIRMED_BY_BACKEND,
  saas_tenant_id,
  updated_at,
  saas_tenant_name,
});

// Regular actions
export const setSaasTenantsAction = (saasTenants: ISaasTenant[]): ISetSaasTenantsAction => ({
  type: SET_SAAS_TENANTS,
  payload: saasTenants,
});

export const addSaasTenantAction = (saasTenant: ISaasTenant): IAddSaasTenantAction => ({
  type: ADD_SAAS_TENANT,
  payload: saasTenant,
});

export const updateSaasTenantAction = (saasTenant: ISaasTenant): IUpdateSaasTenantAction => ({
  type: UPDATE_SAAS_TENANT,
  payload: saasTenant,
});

export const deleteSaasTenantAction = (saas_tenant_id: string): IDeleteSaasTenantAction => ({
  type: DELETE_SAAS_TENANT,
  payload: { saas_tenant_id },
});

export const clearSaasTenantsAction = (): IClearSaasTenantsAction => ({
  type: CLEAR_SAAS_TENANTS,
});

export const updateSaasTenantUsageAction = (
  saas_tenant_id: string,
  usage: { prompt_tokens: number; completion_tokens: number; reasoning_tokens: number },
): IUpdateSaasTenantUsageAction => ({
  type: UPDATE_SAAS_TENANT_USAGE,
  payload: { saas_tenant_id, usage },
});

export const setSaasTenantSearchResultsAction = (searchResults: ISaasTenantSearchResult[]): ISetSaasTenantSearchResultsAction => ({
  type: SET_SAAS_TENANT_SEARCH_RESULTS,
  payload: searchResults,
});

export const setSaasTenantSearchTooManyResultsAction = (tooManyResults: boolean): ISetSaasTenantSearchTooManyResultsAction => ({
  type: SET_SAAS_TENANT_SEARCH_TOO_MANY_RESULTS,
  payload: tooManyResults,
});
